<template>
  <div class="login">
    <div class="login__header">
      <div class="login__title">登录</div>
      <div class="login__sub">龙小主保洁端</div>
    </div>

    <div class="login__card">
      <van-field v-model="mobile" label="手机号" placeholder="请输入手机号" clearable />
      <van-field v-model="password" type="password" label="密码" placeholder="请输入密码" clearable />
      <div class="login__actions">
        <van-button type="primary" block :loading="loading" @click="handleSubmit">登录</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Notify } from 'vant'
import { login } from '@/api/lxz/cleaner'

export default {
  name: 'LoginPage',
  data() {
    return {
      mobile: '',
      password: '',
      loading: false
    }
  },
  methods: {
    async handleSubmit() {
      const mobile = String(this.mobile || '').trim()
      if (!mobile) {
        Notify({ message: '请输入手机号', type: 'danger' })
        return
      }
      const password = String(this.password || '').trim()
      if (!password) {
        Notify({ message: '请输入密码', type: 'danger' })
        return
      }
      this.loading = true
      try {
        const code = sessionStorage.getItem('code') || ''
        const res = await login({ form: { mobile, password, code } })
        const ok = res.status === 200
        const token = res.data.token || ''
        if (!ok || !token) {
          Notify({ message: (res && res.message) || '登录失败', type: 'danger' })
          return
        }

        localStorage.setItem('lxz-token', token)
        Notify({ message: '登录成功', type: 'success' })
        const redirect = this.$route.query && this.$route.query.redirect ? String(this.$route.query.redirect) : ''
        await this.$router.replace(redirect || '/cleanerPage/home')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login {
  padding-top: 200px;
  min-height: 100vh;
  background: #f5f7fa;
  padding-left:16px;
  padding-right: 16px;
  box-sizing: border-box;
}
.login__header {
  margin-bottom: 30px;
}
.login__title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
}
.login__sub {
  font-size: 13px;
  color: #888;
  margin-top: 6px;
}
.login__card {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
}
.login__actions {
  margin-top: 14px;
}
</style>
